:host {
	all: initial;
	font-family: "EYInterstate", "Segoe UI", "Helvetica Neue", Arial, sans-serif;
}

.faas-widget {
	--faas-bg: #ffffff;
	--faas-surface: #f3f6f9;
	--faas-text: #10243e;
	--faas-muted: #5e7088;
	--faas-primary: #1d6fd6;
	--faas-primary-hover: #1159b0;
	--faas-border: #d9e2ec;
	position: fixed;
	z-index: 2147483000;
}

.widget-toast {
	position: absolute;
	top: -44px;
	right: 0;
	max-width: 300px;
	padding: 8px 10px;
	border-radius: 8px;
	border: 1px solid var(--faas-border);
	background: var(--faas-bg);
	color: var(--faas-text);
	font-size: 12px;
	font-weight: 600;
	box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);
	opacity: 0;
	pointer-events: none;
	transform: translateY(8px);
	transition: opacity 140ms ease, transform 140ms ease;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	z-index: 1;
}

.widget-toast.visible {
	opacity: 1;
	transform: translateY(0);
}

.widget-toast.success {
	border-color: #3f8a5f;
	color: #2f7b4e;
}

.widget-toast.error {
	border-color: #b94a4a;
	color: #b02929;
}

.widget-toast.info {
	border-color: #4f7fb3;
	color: #2f5f93;
}

.faas-widget.dark .widget-toast.success {
	color: #6fdaa0;
}

.faas-widget.dark .widget-toast.error {
	color: #ff8d8d;
}

.faas-widget.dark .widget-toast.info {
	color: #9ac8ff;
}

/* Toast alignment follows the widget's selected position/design */
/* Left-anchored positions: align toast to the FAB's left edge */
.bottom-left .widget-toast,
.top-left .widget-toast,
.left-center .widget-toast {
	right: auto;
	left: 0;
}

/* Top-anchored positions: show toast below the widget (avoid going off-screen above) */
.top-left .widget-toast,
.top-right .widget-toast,
.display-tab-horizontal.top-left .widget-toast,
.display-tab-horizontal.top-right .widget-toast {
	top: auto;
	bottom: -44px;
}

.faas-widget.dark {
	--faas-bg: #0f1723;
	--faas-surface: #172231;
	--faas-text: #e7edf4;
	--faas-muted: #a8b7ca;
	--faas-primary: #4c9cff;
	--faas-primary-hover: #3e8be9;
	--faas-border: #2a3b52;
}

.bottom-right {
	right: 18px;
	bottom: 18px;
}

.bottom-left {
	left: 18px;
	bottom: 18px;
}

.top-right {
	right: 18px;
	top: 18px;
}

.top-left {
	left: 18px;
	top: 18px;
}

.left-center {
	left: 18px;
	top: calc(50vh - 24px);
}

.right-center {
	right: 18px;
	top: calc(50vh - 24px);
}

/* Display style: circle (icon-only FAB) */
.display-circle .fab {
	width: 48px;
	height: 48px;
	padding: 0;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.display-circle .fab svg {
	width: 22px;
	height: 22px;
	color: inherit;
}

/* Launcher logo image + name-based initials badge */
.fab-logo {
	width: 24px;
	height: 24px;
	border-radius: 50%;
	object-fit: cover;
	display: block;
}

.fab-logo-inline {
	width: 18px;
	height: 18px;
	vertical-align: middle;
	margin-right: 6px;
	display: inline-block;
}

.fab-initials {
	font-weight: 700;
	font-size: 14px;
	letter-spacing: 0.5px;
	line-height: 1;
	color: inherit;
}

.fab-initials-inline {
	font-size: 12px;
	margin-right: 6px;
	vertical-align: middle;
}

/* Display style: tab (vertical side tab) */
.display-tab .fab {
	writing-mode: vertical-rl;
	text-orientation: mixed;
	border-radius: 8px 0 0 8px;
	padding: 12px 8px;
	font-size: 12px;
	letter-spacing: 1px;
}

.display-tab .fab .tab-label {
	display: block;
}

/* Tab: flush to right edge */
.display-tab.right-center,
.display-tab.top-right,
.display-tab.bottom-right {
	right: 0;
}

.display-tab.right-center .fab,
.display-tab.top-right .fab,
.display-tab.bottom-right .fab {
	border-radius: 8px 0 0 8px;
}

/* Tab: flush to left edge */
.display-tab.left-center,
.display-tab.top-left,
.display-tab.bottom-left {
	left: 0;
}

.display-tab.left-center .fab,
.display-tab.top-left .fab,
.display-tab.bottom-left .fab {
	border-radius: 0 8px 8px 0;
}

/* Display style: tab-horizontal (horizontal strip at top/bottom edge) */
.display-tab-horizontal .fab {
	border-radius: 8px 8px 0 0;
	padding: 8px 18px;
	font-size: 12px;
	font-weight: 600;
	letter-spacing: 0.5px;
	display: flex;
	align-items: center;
	gap: 6px;
}

/* Horizontal tab: flush to bottom edge */
.display-tab-horizontal.bottom-right,
.display-tab-horizontal.bottom-left {
	bottom: 0;
}

.display-tab-horizontal.bottom-right .fab,
.display-tab-horizontal.bottom-left .fab,
.display-tab-horizontal.left-center .fab,
.display-tab-horizontal.right-center .fab {
	border-radius: 8px 8px 0 0;
}

/* Horizontal tab: flush to top edge */
.display-tab-horizontal.top-right,
.display-tab-horizontal.top-left {
	top: 0;
}

.display-tab-horizontal.top-right .fab,
.display-tab-horizontal.top-left .fab {
	border-radius: 0 0 8px 8px;
}

/* Behavior: half-hidden — peek from edge, slide out on hover */
.half-hidden-state {
	transition: transform 0.3s ease;
}

.half-hidden-state .fab {
	opacity: 0.7;
	transition: opacity 0.3s ease;
}

.half-hidden-state:hover .fab,
.half-hidden-state .fab:focus {
	opacity: 1;
}

/* Half-hidden: translate to peek from edge per position */
.half-hidden-state.bottom-right {
	transform: translateX(60%);
}
.half-hidden-state.bottom-right:hover {
	transform: translateX(0);
}

.half-hidden-state.bottom-left {
	transform: translateX(-60%);
}
.half-hidden-state.bottom-left:hover {
	transform: translateX(0);
}

.half-hidden-state.top-right {
	transform: translateX(60%);
}
.half-hidden-state.top-right:hover {
	transform: translateX(0);
}

.half-hidden-state.top-left {
	transform: translateX(-60%);
}
.half-hidden-state.top-left:hover {
	transform: translateX(0);
}

.half-hidden-state.right-center {
	transform: translateX(60%);
}
.half-hidden-state.right-center:hover {
	transform: translateX(0);
}

.half-hidden-state.left-center {
	transform: translateX(-60%);
}
.half-hidden-state.left-center:hover {
	transform: translateX(0);
}

/* Half-hidden: horizontal tab peeks from bottom/top edge */
.half-hidden-state.display-tab-horizontal.bottom-right,
.half-hidden-state.display-tab-horizontal.bottom-left {
	transform: translateY(60%);
}
.half-hidden-state.display-tab-horizontal.bottom-right:hover,
.half-hidden-state.display-tab-horizontal.bottom-left:hover {
	transform: translateY(0);
}

.half-hidden-state.display-tab-horizontal.top-right,
.half-hidden-state.display-tab-horizontal.top-left {
	transform: translateY(-60%);
}
.half-hidden-state.display-tab-horizontal.top-right:hover,
.half-hidden-state.display-tab-horizontal.top-left:hover {
	transform: translateY(0);
}

/* Behavior: auto-hidden (for draggable-hide) */
.auto-hidden {
	opacity: 0.3;
	transition: opacity 0.5s ease;
}

.auto-hidden:hover {
	opacity: 1;
}

/* Draggable widget cursor indicator */
.draggable-widget .fab {
	cursor: grab;
}

.draggable-widget .fab:active {
	cursor: grabbing;
}

/* Panel positioning: for top positions, panel opens below */
.top-right .panel,
.top-left .panel {
	margin-top: 10px;
	margin-bottom: 0;
}

/* Panel positioning: for bottom positions, panel opens above */
.bottom-right,
.bottom-left {
	display: flex;
	flex-direction: column-reverse;
	align-items: flex-end;
}

.bottom-left {
	align-items: flex-start;
}

.bottom-right .panel,
.bottom-left .panel {
	margin-top: 0;
	margin-bottom: 10px;
}

/* Panel positioning: for center positions */
.left-center,
.right-center {
	display: flex;
	flex-direction: column-reverse;
	align-items: flex-end;
}

.left-center {
	align-items: flex-start;
}

/* Center positions: keep the expanded panel itself centered in viewport,
   while the trigger tab/button stays at center edge. */
.right-center:not(.draggable-widget) .panel {
	position: fixed;
	right: 18px;
	top: 50%;
	transform: translateY(-50%);
	margin: 0;
}

.left-center:not(.draggable-widget) .panel {
	position: fixed;
	left: 18px;
	top: 50%;
	transform: translateY(-50%);
	margin: 0;
}

/* Draggable variants must keep panel anchored to the dragged widget. */
.right-center.draggable-widget .panel,
.left-center.draggable-widget .panel {
	position: static;
	top: auto;
	left: auto;
	right: auto;
	transform: none;
}

@media (max-height: 700px) {
	.right-center:not(.draggable-widget) .panel,
	.left-center:not(.draggable-widget) .panel {
		top: 50%;
		transform: translateY(-50%);
		max-height: calc(100vh - 32px);
	}
}

.fab {
	background: linear-gradient(135deg, var(--faas-primary), #27a3e2);
	color: #fff;
	border: 0;
	border-radius: 999px;
	padding: 12px 18px;
	font-weight: 600;
	cursor: pointer;
	box-shadow: 0 12px 28px rgba(8, 29, 56, 0.24);
}

.panel {
	width: min(360px, calc(100vw - 24px));
	border-radius: 16px;
	border: 1px solid var(--faas-border);
	background: var(--faas-bg);
	color: var(--faas-text);
	box-shadow: 0 18px 42px rgba(2, 16, 34, 0.26);
	padding: 11px;
	display: none;
	margin-top: 10px;
}

.panel.open {
	display: flex;
	flex-direction: column;
	max-height: min(500px, calc(100vh - 120px));
	animation: pop 180ms ease-out;
}

/* Fixed header region: title, subtitle and the capture/requests tabs */
.panel.open > .panel-header,
.panel.open > .panel-sub,
.panel.open > .actions-row {
	flex: 0 0 auto;
}

/* Divider under the fixed header (tabs row) to separate it from the body */
.panel.open > .actions-row {
	margin: 6px 0 10px;
	padding-bottom: 10px;
	border-bottom: 1px solid var(--faas-border);
}

/* Views fill remaining height and manage their own internal scroll */
.panel.open > #captureView,
.panel.open > #requestsView {
	display: flex;
	flex-direction: column;
	min-height: 0;
	flex: 1 1 auto;
}

/* Scrollable body */
.view-scroll {
	flex: 1 1 auto;
	min-height: 0;
	overflow-y: auto;
	overflow-x: hidden;
	padding-right: 6px;
	margin-right: -6px;
	scrollbar-width: thin;
	scrollbar-color: var(--faas-border) transparent;
}

.view-scroll::-webkit-scrollbar {
	width: 8px;
}

.view-scroll::-webkit-scrollbar-track {
	background: transparent;
}

.view-scroll::-webkit-scrollbar-thumb {
	background: var(--faas-border);
	border-radius: 8px;
	border: 2px solid transparent;
	background-clip: padding-box;
}

.view-scroll::-webkit-scrollbar-thumb:hover {
	background: var(--faas-muted);
}

/* Fixed footer (submit action) */
.view-footer {
	flex: 0 0 auto;
	padding-top: 8px;
	margin-top: 6px;
	border-top: 1px solid var(--faas-border);
}

@keyframes pop {
	from {
		opacity: 0;
		transform: translateY(8px) scale(0.98);
	}
	to {
		opacity: 1;
		transform: translateY(0) scale(1);
	}
}

.panel-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.panel-header-actions {
	display: flex;
	align-items: center;
	gap: 8px;
}

.theme-toggle {
	display: inline-flex;
	align-items: center;
	padding: 2px;
	border-radius: 999px;
	border: 1px solid var(--faas-border);
	background: var(--faas-surface);
	gap: 2px;
}

.theme-toggle-btn {
	padding: 5px 10px;
	border-radius: 999px;
	border: 0;
	background: transparent;
	color: var(--faas-muted);
	font-size: 11px;
	font-weight: 700;
	line-height: 1;
}

.theme-toggle-btn.icon-only {
	width: 30px;
	height: 30px;
	padding: 0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.theme-toggle-btn.icon-only svg {
	flex: 0 0 auto;
}

.theme-toggle-btn.active {
	background: var(--faas-primary);
	color: #fff;
}

.panel-header h3 {
	margin: 0;
	font-size: 16px;
}

.panel-sub {
	margin: 3px 0 8px;
	color: var(--faas-muted);
	font-size: 12px;
}

.label {
	font-size: 12px;
	margin-bottom: 3px;
	display: block;
}

.req-mark {
	color: #dc2626;
	font-weight: 700;
	margin-left: 2px;
}

.input {
	width: 100%;
	border: 1px solid var(--faas-border);
	background: var(--faas-surface);
	color: var(--faas-text);
	border-radius: 10px;
	padding: 9px;
	font-size: 14px;
	box-sizing: border-box;
	margin-bottom: 7px;
}

/* Read-only field (e.g. Page) rendered to look disabled and non-editable */
.input-readonly,
.input-readonly:focus,
.input-readonly:hover,
.input-readonly:active {
	background: var(--faas-bg);
	color: var(--faas-muted);
	cursor: not-allowed;
	border-style: dashed;
	border-color: var(--faas-border);
	box-shadow: none;
	outline: none;
	user-select: none;
	pointer-events: none;
}

.actions-row {
	display: flex;
	align-items: center;
	gap: 8px;
	margin: 6px 0;
}

#captureView textarea.input {
	min-height: 88px;
	line-height: 1.3;
}

#captureView .hint {
	margin: 2px 0 6px;
}

.actions-row.end {
	justify-content: flex-end;
}

.actions-row-between {
	justify-content: space-between;
}

.hint {
	color: var(--faas-muted);
	font-size: 12px;
	margin: 0;
}

.admin-login-link-hint {
	margin: 8px 0 0;
}

.admin-login-link {
	color: var(--faas-primary);
	font-weight: 600;
	text-decoration: underline;
	cursor: pointer;
}

.admin-login-link:hover {
	color: var(--faas-primary-hover);
}

button {
	border: 0;
	border-radius: 10px;
	cursor: pointer;
	padding: 8px 12px;
	font-size: 12px;
	font-weight: 600;
}

button:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.icon-btn {
	width: 38px;
	height: 38px;
	padding: 0;
	font-size: 18px;
	line-height: 1;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.primary {
	background: var(--faas-primary);
	color: #fff;
}

.btn-with-icon {
	display: inline-flex;
	align-items: center;
	gap: 6px;
}

.btn-with-icon svg {
	flex: 0 0 auto;
}

.primary:hover {
	background: var(--faas-primary-hover);
}

.secondary {
	background: #e6eef8;
	color: #1e3857;
}

.faas-widget.dark .secondary {
	background: #23354a;
	color: #d8e6f7;
}

.ghost {
	background: transparent;
	color: var(--faas-muted);
	border: 1px solid var(--faas-border);
}

.status {
	margin: 8px 0 0;
	color: #1f7a40;
	font-size: 12px;
}

.status.error {
	color: #b3261e;
}

.hidden {
	display: none !important;
}

.active-tab {
	border-color: var(--faas-primary) !important;
	color: var(--faas-primary) !important;
}

.tab-count-badge {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 18px;
	height: 18px;
	padding: 0 5px;
	border-radius: 999px;
	font-size: 11px;
	font-weight: 700;
	line-height: 1;
	background: var(--faas-primary);
	color: #fff;
	margin-left: 4px;
	vertical-align: middle;
}

.requests-list {
	max-height: 200px;
	overflow: auto;
	border: 1px solid var(--faas-border);
	border-radius: 10px;
	background: var(--faas-surface);
	margin-bottom: 10px;
}

.requests-table {
	width: 100%;
	border-collapse: collapse;
	font-size: 12px;
	min-width: 0;
	table-layout: fixed;
}

.requests-table thead th {
	text-align: left;
	padding: 10px;
	font-size: 11px;
	font-weight: 700;
	color: var(--faas-muted);
	text-transform: uppercase;
	letter-spacing: 0.03em;
	border-bottom: 1px solid var(--faas-border);
	position: sticky;
	top: 0;
	background: var(--faas-surface);
	z-index: 1;
}

.requests-table tbody td {
	padding: 10px;
	border-bottom: 1px solid var(--faas-border);
	vertical-align: top;
}

.requests-table th:nth-child(1),
.requests-table td:nth-child(1) {
	width: 22%;
}

.requests-table th:nth-child(2),
.requests-table td:nth-child(2) {
	width: 14%;
}

.requests-table th:nth-child(3),
.requests-table td:nth-child(3) {
	width: 12%;
}

.requests-table th:nth-child(4),
.requests-table td:nth-child(4) {
	width: 14%;
	white-space: normal;
}

.requests-table th:nth-child(5),
.requests-table td:nth-child(5) {
	width: 18%;
	white-space: normal;
}

.requests-table th:nth-child(6),
.requests-table td:nth-child(6) {
	width: 8%;
	white-space: nowrap;
}

.requests-table th:nth-child(7),
.requests-table td:nth-child(7) {
	width: 12%;
	white-space: nowrap;
}

.request-submitter {
	display: inline-block;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: var(--faas-muted);
}

.request-comment-preview {
	line-height: 1.35;
	max-height: 2.7em;
	overflow: hidden;
	display: -webkit-box;
	line-clamp: 2;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	color: var(--faas-muted);
}

.requests-pager {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
	font-size: 11px;
	color: var(--faas-muted);
}

.pager-actions {
	display: flex;
	align-items: center;
	gap: 6px;
}

.pager-page {
	min-width: 52px;
	text-align: center;
	font-weight: 700;
	color: var(--faas-text);
}

.request-table-row {
	cursor: pointer;
	transition: background 120ms ease;
}

.request-table-row:hover {
	background: rgba(29, 111, 214, 0.08);
}

.request-table-row.selected {
	background: rgba(29, 111, 214, 0.14);
	outline: 1px solid rgba(29, 111, 214, 0.35);
	outline-offset: -1px;
}

.request-sub {
	font-size: 11px;
	color: var(--faas-muted);
	margin-top: 4px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	display: flex;
	align-items: center;
	gap: 6px;
}

.request-update-badge {
	display: inline-flex;
	align-items: center;
	padding: 1px 6px;
	border-radius: 999px;
	font-size: 10px;
	font-weight: 700;
	line-height: 1.4;
	background: rgba(29, 111, 214, 0.12);
	color: var(--faas-primary);
	border: 1px solid rgba(29, 111, 214, 0.35);
	flex-shrink: 0;
}

.request-title {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.request-row {
	width: 100%;
	text-align: left;
	display: block;
	background: transparent;
	border: 0;
	padding: 10px;
	border-bottom: 1px solid var(--faas-border);
	border-radius: 0;
}

.request-row:last-child {
	border-bottom: 0;
}

.request-row:hover {
	background: rgba(29, 111, 214, 0.08);
}

.request-row.selected {
	background: rgba(29, 111, 214, 0.14);
	outline: 1px solid rgba(29, 111, 214, 0.35);
}

.request-title {
	font-size: 13px;
	font-weight: 700;
	color: var(--faas-text);
	margin-bottom: 6px;
}

.request-meta {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	font-size: 11px;
	color: var(--faas-muted);
}

.request-detail {
	border: 1px solid var(--faas-border);
	border-radius: 10px;
	padding: 10px;
	background: var(--faas-surface);
}

.request-detail-hero {
	border: 1px solid var(--faas-border);
	border-radius: 12px;
	padding: 12px;
	background: linear-gradient(180deg, rgba(29, 111, 214, 0.08), rgba(29, 111, 214, 0.02));
	margin-bottom: 12px;
}

.request-id-pill {
	display: inline-flex;
	align-items: center;
	max-width: 220px;
	padding: 4px 10px;
	border-radius: 999px;
	border: 1px solid var(--faas-border);
	background: var(--faas-bg);
	font-size: 11px;
	font-weight: 700;
	color: var(--faas-muted);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.request-meta-list {
	display: grid;
	gap: 8px;
	margin-top: 12px;
}

.request-meta-row {
	position: relative;
	border: 1px solid var(--faas-border);
	border-radius: 10px;
	padding: 10px 12px 10px 14px;
	background: var(--faas-bg);
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 4px;
	overflow: hidden;
}

.request-meta-row::before {
	content: '';
	position: absolute;
	left: 0;
	top: 0;
	bottom: 0;
	width: 3px;
	background: rgba(29, 111, 214, 0.55);
	border-radius: 3px 0 0 3px;
}

.request-meta-label {
	font-size: 10px;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.06em;
	color: var(--faas-muted);
}

.request-meta-value {
	font-size: 13px;
	line-height: 1.5;
	font-weight: 600;
	color: var(--faas-text);
	word-break: break-word;
	text-align: left;
}

.request-meta-row .request-meta-value {
	max-width: 100%;
}

.dashboard-dialog {
	position: fixed;
	inset: 0;
	z-index: 2147483950;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 16px;
	box-sizing: border-box;
}

/* Keep the "Open Requests" dialog centered on the viewport for ANY widget
   design/position. Center-positioned widgets apply a transform to the panel
   (and half-hidden states transform the root), which would otherwise
   re-anchor this position:fixed overlay to that ancestor's box instead of the
   page. While the dialog is open the widget sits behind the full-screen
   backdrop, so neutralizing these transforms is visually safe. */
.faas-widget.dashboard-open,
.faas-widget.dashboard-open .panel {
	transform: none !important;
}

.dashboard-backdrop {
	position: absolute;
	inset: 0;
	background: rgba(4, 17, 34, 0.45);
	backdrop-filter: blur(2px);
}

.dashboard-card {
	position: relative;
	z-index: 1;
	width: min(920px, calc(100vw - 32px));
	max-height: min(88vh, 760px);
	display: flex;
	flex-direction: column;
	gap: 10px;
	background: var(--faas-bg);
	border: 1px solid var(--faas-border);
	border-radius: 14px;
	box-shadow: 0 20px 44px rgba(5, 19, 37, 0.28);
	padding: 12px;
	box-sizing: border-box;
}

.dashboard-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
}

.dashboard-tabs {
	display: inline-flex;
	gap: 6px;
	align-items: center;
}

.dash-tab {
	padding: 6px 12px;
	border-radius: 999px;
	border: 1px solid var(--faas-border);
	background: transparent;
	color: var(--faas-muted);
	font-size: 12px;
	font-weight: 700;
}

.dash-tab.active {
	border-color: var(--faas-primary);
	background: rgba(29, 111, 214, 0.16);
	color: var(--faas-primary);
}

.dashboard-header h4 {
	margin: 0;
	font-size: 15px;
}

.dashboard-body {
	display: grid;
	grid-template-columns: minmax(440px, 1.1fr) minmax(340px, 1fr);
	gap: 10px;
	overflow: hidden;
	min-height: 280px;
}

.dashboard-body.mode-table,
.dashboard-body.mode-detail {
	grid-template-columns: 1fr;
}

.dashboard-left-pane {
	display: grid;
	grid-template-rows: auto 1fr auto;
	gap: 8px;
	overflow: hidden;
}

.requests-toolbar {
	display: grid;
	gap: 8px;
}

.requests-search {
	margin-bottom: 0;
}

.status-filters {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}

.requests-filter-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	position: relative;
}

.filter-summary {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	min-width: 0;
}

.filter-trigger {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 6px 12px;
	font-size: 12px;
	font-weight: 700;
	white-space: nowrap;
}

.filter-trigger.active {
	border-color: var(--faas-primary);
	color: var(--faas-primary);
	background: rgba(29, 111, 214, 0.14);
}

.user-filter-backdrop {
	position: fixed;
	inset: 0;
	z-index: 1100;
	background: rgba(0, 0, 0, 0.18);
}

.user-filter-panel {
	position: fixed;
	z-index: 1200;
	width: 320px;
	max-width: calc(100vw - 16px);
	max-height: calc(100vh - 16px);
	border: 1px solid var(--faas-border);
	border-radius: 14px;
	padding: 0;
	background: var(--faas-surface);
	box-shadow: 0 12px 40px rgba(0, 0, 0, 0.14);
	overflow: hidden;
	display: flex;
	flex-direction: column;
}

.user-filter-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	padding: 14px 16px 10px;
	flex-shrink: 0;
	border-bottom: 1px solid var(--faas-border);
}

.user-filter-scroll-body {
	flex: 1;
	overflow-y: auto;
	min-height: 0;
}

.user-filter-head-actions {
	display: flex;
	align-items: center;
	gap: 8px;
}

.user-filter-head h5 {
	margin: 0;
	font-size: 15px;
	font-weight: 700;
}

.filter-clear-btn {
	font-size: 12px;
	font-weight: 700;
	color: var(--faas-primary);
	border: none;
	padding: 4px 6px;
}

.filter-close-btn {
	width: 32px;
	height: 32px;
	border-radius: 10px;
	padding: 0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.user-filter-subtitle {
	margin: 4px 16px 0;
	font-size: 12px;
}

.user-filter-search-wrap {
	position: relative;
	margin: 10px 16px 4px;
}

.user-filter-search-icon {
	position: absolute;
	left: 10px;
	top: 50%;
	transform: translateY(-50%);
	color: var(--faas-muted);
	pointer-events: none;
}

.user-filter-search-input {
	width: 100%;
	box-sizing: border-box;
	padding-left: 30px !important;
	margin-bottom: 0;
}

.user-filter-list {
	display: flex;
	flex-direction: column;
	gap: 0;
}

.user-filter-option {
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
	padding: 10px 6px;
	border: none;
	border-bottom: 1px solid var(--faas-border);
	border-radius: 0;
	background: transparent;
	text-align: left;
	color: var(--faas-text);
	font-size: 13px;
	cursor: pointer;
}

.user-filter-option:last-child {
	border-bottom: none;
}

.user-filter-option-check {
	width: 16px;
	height: 16px;
	border: 1.5px solid var(--faas-border);
	border-radius: 4px;
	background: var(--faas-bg);
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.user-filter-option.selected .user-filter-option-check {
	border-color: var(--faas-primary);
	background: var(--faas-primary);
}

.user-filter-option-name {
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.user-filter-option-count {
	font-size: 12px;
	font-weight: 600;
	color: var(--faas-muted);
	margin-left: auto;
	white-space: nowrap;
}

.user-filter-footer {
	border-top: 1px solid var(--faas-border);
	padding: 10px 16px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	flex-shrink: 0;
}

.user-filter-selected-count {
	font-size: 12px;
	color: var(--faas-muted);
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	flex-shrink: 1;
}

.user-filter-footer-actions {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-shrink: 0;
}

.filter-section {
	border-top: 1px solid var(--faas-border);
}

.filter-section-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding: 10px 16px;
	border: none;
	background: transparent;
	color: var(--faas-text);
	font-size: 13px;
	font-weight: 700;
	cursor: pointer;
	text-align: left;
}

.filter-section-head:hover {
	background: rgba(0, 0, 0, 0.03);
}

.filter-section-chevron {
	color: var(--faas-muted);
	transition: transform 0.18s ease;
	flex-shrink: 0;
}

.filter-section-chevron.collapsed {
	transform: rotate(-90deg);
}

.filter-section-body {
	padding: 0 16px 8px;
	max-height: 180px;
}

.filter-section-title {
	font-weight: 700;
	font-size: 13px;
}

.chip {
	padding: 5px 10px;
	font-size: 11px;
	border-radius: 999px;
	border: 1px solid var(--faas-border);
	background: transparent;
	color: var(--faas-muted);
}

.chip.active {
	border-color: var(--faas-primary);
	background: rgba(29, 111, 214, 0.16);
	color: var(--faas-primary);
}

.status-inline-select {
	width: 100%;
	min-width: 0;
	padding: 6px 8px;
	font-size: 12px;
	border-radius: 999px;
	border: 1px solid var(--faas-border);
	background: var(--faas-bg);
	color: var(--faas-text);
	font-weight: 700;
}

.dashboard-body .requests-list,
.dashboard-body .request-detail {
	height: 100%;
	max-height: calc(88vh - 120px);
	overflow: auto;
}

.dashboard-body.mode-detail .request-detail {
	overflow-x: hidden;
	padding-right: 8px;
}

@media (max-width: 760px) {
	.dashboard-dialog {
		justify-content: center;
		padding: 12px;
	}

	.dashboard-card {
		max-height: calc(100vh - 24px);
	}

	.dashboard-body {
		grid-template-columns: 1fr;
		grid-template-rows: minmax(240px, 380px) 1fr;
	}
}

.request-detail-title {
	margin: 0 0 6px;
	font-size: 14px;
	line-height: 1.35;
	word-break: break-word;
}

.request-detail-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
	margin-bottom: 8px;
}

.request-detail-tools {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	flex-shrink: 0;
}

.export-chip {
	font-size: 11px;
	font-weight: 600;
	padding: 4px 10px;
	border-radius: 999px;
	line-height: 1.4;
	white-space: nowrap;
	cursor: pointer;
}

.request-detail-grid {
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
	gap: 12px;
	align-items: start;
}

.request-detail-main,
.request-detail-side {
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.rating-block {
	margin: 8px 0 12px;
}

.rating-label {
	display: block;
	margin-bottom: 6px;
}

.rating-stars {
	display: flex;
	align-items: center;
	gap: 4px;
}

.rating-star {
	border: none;
	background: transparent;
	color: #cbd5e1;
	font-size: 26px;
	line-height: 1;
	padding: 2px 3px;
	cursor: pointer;
	transition: color 120ms ease, transform 120ms ease;
	border-radius: 6px;
}

.rating-star:hover,
.rating-star:focus-visible {
	color: #f59e0b;
	transform: scale(1.06);
	outline: none;
}

.rating-star.active {
	color: #f59e0b;
}

.faas-widget.dark .rating-star {
	color: #475569;
}

.faas-widget.dark .rating-star:hover,
.faas-widget.dark .rating-star:focus-visible,
.faas-widget.dark .rating-star.active {
	color: #fbbf24;
}

.request-detail-desc {
	margin: 6px 0 10px;
	font-size: 13px;
	line-height: 1.45;
	color: var(--faas-text);
}

.request-summary-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;
	margin-bottom: 10px;
}

.request-summary-main {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;
	min-width: 0;
}

.request-summary-date {
	font-size: 12px;
	color: var(--faas-muted);
	white-space: nowrap;
}

.detail-card {
	width: 100%;
	height: auto;
}

.retention-banner {
	border: 1px solid var(--faas-border);
	border-radius: 12px;
	padding: 12px 14px;
	display: grid;
	gap: 10px;
}

.retention-banner.retention-soon {
	border-color: #e3c06a;
	background: rgba(224, 160, 32, 0.1);
}

.retention-banner.retention-critical {
	border-color: #e0686d;
	background: rgba(224, 72, 77, 0.1);
}

.retention-banner.retention-ok {
	border-color: var(--faas-border);
	background: rgba(120, 130, 150, 0.06);
}

.retention-head {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 10px;
	flex-wrap: wrap;
}

.retention-title {
	margin: 0;
	font-size: 13px;
	font-weight: 700;
	color: var(--faas-text);
}

.retention-sub {
	margin: 4px 0 0;
	font-size: 12px;
	line-height: 1.45;
	color: var(--faas-muted);
}

.retention-pill {
	flex-shrink: 0;
	font-size: 11px;
	font-weight: 600;
	padding: 3px 9px;
	border-radius: 999px;
	border: 1px solid var(--faas-border);
	background: var(--faas-surface);
	color: var(--faas-text);
}

.retention-toggle {
	align-self: flex-start;
}

.retention-form {
	display: grid;
	gap: 10px;
	border-top: 1px solid var(--faas-border);
	padding-top: 10px;
}

.retention-field {
	display: grid;
	gap: 4px;
	font-size: 12px;
	font-weight: 600;
	color: var(--faas-text);
}

.retention-form .hint.error {
	color: #c0392b;
}

.request-detail-stack {
	display: grid;
	gap: 12px;
}

.request-action-card,
.activity-card {
	border: 1px solid var(--faas-border);
	border-radius: 10px;
	padding: 10px;
	background: var(--faas-bg);
}

.request-action-card {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
}

.readonly-review-card {
	gap: 10px;
}

.readonly-review-list {
	display: grid;
	gap: 6px;
}

.readonly-review-row {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 10px;
	padding: 8px 10px;
	border: 1px solid var(--faas-border);
	border-radius: 8px;
	background: var(--faas-surface);
}

.readonly-review-label {
	font-size: 11px;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.03em;
	color: var(--faas-muted);
}

.readonly-review-value {
	font-size: 12px;
	font-weight: 600;
	color: var(--faas-text);
	text-align: right;
	word-break: break-word;
}

.readonly-review-note {
	margin: 0;
	font-size: 12px;
	line-height: 1.45;
	color: var(--faas-muted);
}

.request-action-title {
	margin: 0 0 8px;
	font-size: 12px;
	font-weight: 700;
	color: var(--faas-muted);
	text-transform: uppercase;
	letter-spacing: 0.03em;
}

.request-comment-input {
	margin-bottom: 10px;
}

.action-buttons {
	display: flex;
	gap: 8px;
	flex-wrap: wrap;
}

.action-buttons > button {
	flex: 1 1 100px;
}

.table-delete-btn {
	padding: 6px;
	width: 30px;
	height: 30px;
	min-width: 30px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 11px;
	line-height: 1;
}

.ghost.danger {
	border-color: #e8c4c8;
	color: #9b2230;
	background: #fff5f6;
}

.ghost.danger:hover {
	border-color: #d78790;
	background: #ffe9ec;
}

.confirm-dialog {
	position: fixed;
	inset: 0;
	z-index: 2147483800;
	display: grid;
	place-items: center;
	padding: 16px;
}

.confirm-dialog.hidden {
	display: none;
}

.confirm-backdrop {
	position: absolute;
	inset: 0;
	background: rgba(8, 12, 20, 0.55);
	backdrop-filter: blur(2px);
}

.confirm-card {
	position: relative;
	max-width: 420px;
	width: 100%;
	background: var(--faas-panel-bg);
	color: var(--faas-text);
	border: 1px solid var(--faas-border);
	border-radius: 14px;
	padding: 18px;
	box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
	display: grid;
	gap: 10px;
}

.confirm-icon {
	width: 30px;
	height: 30px;
	border-radius: 999px;
	background: #fff1f2;
	color: #9b2230;
	border: 1px solid #f5ccd0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.confirm-card h5 {
	margin: 0;
	font-size: 16px;
	line-height: 1.3;
}

.confirm-message {
	margin: 0;
	font-size: 13px;
	line-height: 1.5;
	color: var(--faas-muted);
}

.confirm-actions {
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	margin-top: 4px;
}

.requests-toolbar-actions {
	display: flex;
	align-items: center;
	gap: 8px;
}

.export-card {
	max-width: 460px;
	text-align: left;
}

.export-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
}

.export-head h5 {
	margin: 0;
	font-size: 16px;
	line-height: 1.3;
}

.export-field {
	display: grid;
	gap: 6px;
}

.export-label {
	font-size: 12px;
	font-weight: 700;
	color: var(--faas-muted);
}

.export-format-options {
	display: flex;
	gap: 16px;
}

.export-radio,
.export-check {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 13px;
	color: var(--faas-text);
	cursor: pointer;
}

.export-date-row {
	grid-template-columns: 1fr 1fr;
	gap: 12px;
}

.export-date {
	display: grid;
	gap: 6px;
}

.export-date .input {
	margin-bottom: 0;
}

.export-status-list {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 6px 16px;
}

.export-status-message {
	min-height: 16px;
}

.export-status-message.error {
	color: #b3261e;
}

.request-image-card {
	margin: 10px 0;
	border: 1px solid var(--faas-border);
	border-radius: 10px;
	padding: 8px;
	background: var(--faas-bg);
}

.request-detail-main .request-image-card,
.request-detail-side .request-action-card {
	margin: 0;
}

.request-image-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 11px;
	color: var(--faas-muted);
	margin-bottom: 8px;
}

.request-image-open {
	text-decoration: none;
	padding: 4px 8px;
	border-radius: 8px;
	font-size: 11px;
	line-height: 1;
}

.request-image {
	display: block;
	width: 100%;
	max-height: 320px;
	object-fit: contain;
	border-radius: 8px;
	background: #0b1320;
}

.status-chip {
	display: inline-flex;
	align-items: center;
	padding: 3px 8px;
	border-radius: 999px;
	font-size: 10px;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	background: #dde7f3;
	color: #294262;
}

.status-pending {
	background: #f7efd2;
	color: #6f5415;
}

.status-approved {
	background: #d9f4e3;
	color: #205a36;
}

.status-rejected {
	background: #f7dde0;
	color: #7a2230;
}

.status-comment {
	background: #e1e5fb;
	color: #303f8f;
}

.status-generic {
	background: #dde7f3;
	color: #294262;
}

.activity-list {
	margin: 8px 0 0;
	padding: 0;
	list-style: none;
	display: grid;
	gap: 8px;
}

.activity-item {
	border: 1px solid var(--faas-border);
	border-radius: 8px;
	padding: 8px;
	background: var(--faas-bg);
}

.activity-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	font-size: 11px;
	color: var(--faas-muted);
	flex-wrap: wrap;
}

.activity-head span {
	word-break: break-word;
}

.activity-note {
	margin-top: 6px;
	font-size: 12px;
	color: var(--faas-text);
}

@media (max-width: 980px) {
	.request-detail-grid {
		grid-template-columns: 1fr;
	}

	.request-id-pill {
		max-width: 100%;
	}

	.request-meta-row {
		flex-direction: column;
		gap: 4px;
	}

	.request-meta-row .request-meta-value {
		max-width: 100%;
		text-align: left;
	}

	.readonly-review-row {
		flex-direction: column;
		gap: 3px;
	}

	.readonly-review-value {
		text-align: left;
	}
}

/* ── Snippet overlay ─────────────────────────────────────────────────────── */
.snip-overlay {
	position: fixed;
	inset: 0;
	z-index: 2147483900;
	background: rgba(10, 14, 24, 0.88);
	display: flex;
	flex-direction: column;
	overflow: hidden;
	font-family: "EYInterstate", "Segoe UI", "Helvetica Neue", Arial, sans-serif;
}

.snip-overlay.hidden {
	display: none;
}

.snip-toolbar {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 10px 12px;
	background: #1a1a2e;
	border-bottom: 1px solid #303a56;
}

.snip-help {
	font-size: 13px;
	font-weight: 600;
	color: #e6ebf5;
}

.snip-spacer {
	flex: 1;
}

.snip-cancel {
	background: #3a2222;
	color: #ffb6b6;
	border: 1px solid #6b3030;
	border-radius: 6px;
	padding: 6px 12px;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
}

.snip-confirm {
	background: #1f5eff;
	color: #fff;
	border: 1px solid #2a66ff;
	border-radius: 6px;
	padding: 6px 12px;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
}

.snip-confirm:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.snip-canvas-wrap {
	position: relative;
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	padding: 12px;
}

#snipCanvas {
	max-width: 100%;
	max-height: 100%;
	object-fit: contain;
	border: 1px solid #465274;
	box-shadow: 0 14px 30px rgba(0, 0, 0, 0.35);
	cursor: crosshair;
}

.snip-rect {
	position: absolute;
	border: 2px solid #4c9cff;
	background: rgba(76, 156, 255, 0.18);
	pointer-events: none;
	box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.38);
}

.snip-rect.hidden {
	display: none;
}

/* ── Annotation overlay ─────────────────────────────────────────────────── */
.annot-overlay {
	position: fixed;
	inset: 0;
	z-index: 2147484000;
	background: #111;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	font-family: "EYInterstate", "Segoe UI", "Helvetica Neue", Arial, sans-serif;
}

.annot-overlay.hidden {
	display: none;
}

.annot-toolbar {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 8px 12px;
	background: #1a1a2e;
	flex-shrink: 0;
	flex-wrap: wrap;
}

.annot-tool {
	border: 2px solid transparent;
	background: #2d2d50;
	color: #e0e0ff;
	border-radius: 6px;
	padding: 5px 10px;
	cursor: pointer;
	font-size: 13px;
	font-weight: 600;
	transition: border-color 0.12s;
}

.annot-tool.active {
	border-color: #4c9cff;
	background: #1f3a6e;
}

.annot-tool:hover {
	background: #393970;
}

.annot-sep {
	width: 1px;
	height: 22px;
	background: #444;
}

.annot-color {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	border: 2px solid #555;
	cursor: pointer;
	padding: 0;
	background: none;
}

.annot-size {
	width: 80px;
	accent-color: #4c9cff;
	cursor: pointer;
}

.annot-spacer {
	flex: 1;
}

.annot-label {
	font-size: 11px;
	color: #aaa;
	margin-right: 2px;
}

.annot-retake {
	background: #3a2222;
	color: #ff9090;
	border: 1px solid #6b3030;
	border-radius: 6px;
	padding: 5px 12px;
	cursor: pointer;
	font-size: 12px;
	font-weight: 600;
}

.annot-done {
	background: #1f5eff;
	color: #fff;
	border: none;
	border-radius: 6px;
	padding: 5px 14px;
	cursor: pointer;
	font-size: 12px;
	font-weight: 600;
}

.annot-canvas-wrap {
	position: relative;
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}

.annot-canvas-wrap canvas {
	position: absolute;
	max-width: 100%;
	max-height: 100%;
	object-fit: contain;
	display: block;
}

#annotDrawCanvas {
	cursor: crosshair;
}

@media (max-width: 480px) {
	.fab {
		width: 100%;
		border-radius: 14px;
	}
}

/* Upload drop zone */
.upload-drop-zone {
	border: 2px dashed var(--faas-border);
	border-radius: 10px;
	padding: 20px 12px;
	text-align: center;
	cursor: pointer;
	transition: border-color 140ms ease, background 140ms ease;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	user-select: none;
}

.upload-drop-zone:hover,
.upload-drop-zone.drag-over {
	border-color: var(--faas-primary);
	background: color-mix(in srgb, var(--faas-primary) 6%, transparent);
}

.upload-drop-zone[data-has-file='true'] {
	border-color: #3f8a5f;
	background: color-mix(in srgb, #3f8a5f 6%, transparent);
}

.upload-drop-icon {
	color: var(--faas-muted);
	margin-bottom: 2px;
	background: var(--faas-surface);
	border-radius: 50%;
	padding: 8px;
	width: 36px;
	height: 36px;
	box-sizing: content-box;
}

.upload-drop-zone.drag-over .upload-drop-icon,
.upload-drop-zone:hover .upload-drop-icon {
	color: var(--faas-primary);
}

.upload-drop-title {
	font-size: 12px;
	color: var(--faas-text);
	margin: 0;
	line-height: 1.4;
}

.upload-drop-hint {
	font-size: 11px;
	color: var(--faas-muted);
	margin: 0;
}
